import styled from 'styled-components';
import { LinkWithNativeEvents } from '../../../../components/_common/link/link';

export const SectionWrapper = styled.div`
  max-width: 912px;
  background: var(--cvna-color-white);
  border: 1px solid var(--cvna-color-grey-2);
  box-sizing: border-box;
  box-shadow: var(--cvna-elevation-1);
  border-radius: 8px;
  margin: 0 auto;
  overflow: visible;
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
`;

export const SectionContent = styled.div<{
  hasProgressBar?: boolean;
  isDirectlyAboveFooter?: boolean;
  children?: any;
  completed?: boolean;
}>`
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: auto;
  -ms-grid-rows: auto auto;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  border-top: 1px solid var(--cvna-color-grey-2);
  margin-top: 24px;
  padding-bottom: 0;
  padding-top: 24px;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    -ms-grid-columns: 32% 68%;
    grid-template-columns: ${(props) => (props.completed ? 'auto' : '32% 68%')};
  }
`;

export const TextContent = styled.div<{
  showProgress?: boolean;
  children?: any;
}>`
  width: 100%;
  min-width: 100%;
  -ms-grid-column: 1;
  -ms-grid-row: 2;
  grid-column: 1 / 2;
  grid-row: 2 / 3;
  text-align: center;
  font-size: 15px;
  line-height: 18px;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    width: auto;
    -ms-grid-column: 2;
    -ms-grid-row: 1;
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    padding: 0 40px 0 0;
    text-align: left;
  } ;
`;

export const TextBox = styled.p<{
  noBottomMargin?: boolean;
}>`
  margin-bottom: ${(props) => (props.noBottomMargin ? '0px' : '24px')};
`;

export const MultilineText = styled.div<{
  noBottomMargin?: boolean;
  children?: any;
}>`
  margin-bottom: ${(props) => (props.noBottomMargin ? '0px' : '24px')};
  text-align: left;
`;

export const MobileFooter = styled.div<{
  showFooter: boolean;
  children: any;
}>`
  display: ${(props) => (!props.showFooter ? 'none' : 'block')};
  background-color: #edeff1;
  margin-top: 20px;
  padding: 20px 20px;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    display: none;
  }
`;

export const LoadingMessage = styled.p`
  margin: 0;
  padding: 0;
`;

export const ErrorMessage = styled.p`
  margin: 0;
  padding: 0;
`;

export const A = styled(LinkWithNativeEvents)`
  color: var(--cvna-color-blue-2);
  font-weight: 700;
`;

export const Footnote = styled.p`
  font-size: 12px;
  margin: 39px 0 0;
`;

export const SectionItemHeader = styled.h3`
  font-size: 24px;
`;
